import { render, staticRenderFns } from "./SettingsVip.vue?vue&type=template&id=09149534&"
import script from "./SettingsVip.vue?vue&type=script&lang=js&"
export * from "./SettingsVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports